<template>
    <div id="content">
        <div class="container content-container">
            <div id="not-found-page">
                <div class="row">
                    <div class="col-7">
                        <h1>{{ translate.home.page404_1 }}</h1>
                        <h2>{{ translate.home.page404_2 }}<br/>Err: 404</h2>
                        <h4>{{ translate.home.page404_3 }}</h4>
                        <h5>{{ translate.home.page404_4 }}</h5>
                        <ul>
                            <li v-for="location in lodash.get(regionData,'404Locations')"><a :href="regionRelativeUrl(location.path)">{{ location.name}}</a></li>
                        </ul>
                    </div>
                    <div class="col-5 d-flex justify-content-center">
                        <img class="not-found-image" src="/images/404.jpg" alt=""/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";

const data = () => {
    return {
        lodash: _,
        appHadSidebar: false
    }
}

function mounted() {
    this.appHadSidebar = $('#app').hasClass('hasSidebar');
    $('#app').removeClass('hasSidebar');
}

export default {
    data,
    mounted,
    computed: {
        ...mapState(['translate', 'regionData']),
    },
    beforeDestroy() {
        if (this.appHadSidebar) {
            $('#app').addClass('hasSidebar');
        }
    },
    mixins: [regionsUrlMixin]
}
</script>
